module.exports = __webpack_public_path__ + "static/media/collectives-challenges.70412e45.png";